var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentIs,_vm._g(_vm._b({tag:"component",class:_vm.classes,attrs:{"to":_vm.to,"data-content":_vm.innerText}},'component',_vm.$attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }